import React, { memo } from "react";

import { InputAdornment } from "@mui/material";

export type UnitAdornmentProps = {
  unit: string | null | undefined;
};

const NumberInputEndAdornment = ({ unit }: UnitAdornmentProps) => {
  if (!unit) {
    return null;
  }

  return (
    <InputAdornment position="end" disableTypography>
      {unit}
    </InputAdornment>
  );
};

export default memo(NumberInputEndAdornment);
